import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';

const PickupAndDeliveryZone = ({ skus = [], getText = () => {} }) => {
    const renderContent = () => {
        return (
            <Text
                fontSize='sm'
                color='gray'
            >
                Pickup & Delivery Zone
            </Text>
        );
    };

    return (
        <CompareZoneBase
            skus={skus}
            getText={getText}
            titleKey='pickupAndDelivery'
            renderContent={renderContent}
        />
    );
};

PickupAndDeliveryZone.propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(PickupAndDeliveryZone, 'PickupAndDeliveryZone');
